<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="mb-3">
        <vs-input :label="$t('number')" :placeholder="$t('number')" v-model="formData.number" class="w-full"/>
        <validation-error :model-error="formDataErrors.number"></validation-error>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import CallbackNumber from '@/models/CallbackNumber'

export default {
  name: 'Shared.Messages.CallbackNumbers.Edit',
  data () {
    return {
      formData: {},
      formDataErrors: {}
    }
  },
  mounted () {
    EventBus.$on('initCallbackNumberResetFormData', this.resetFormData)
    EventBus.$on('initCallbackNumberGetFormData', this.getFormData)
    EventBus.$on('initUpdateCallbackNumber', this.updateFormData)
  },
  methods: {
    resetFormData () {
      this.formData = {
        number: ''
      }
      this.formDataErrors = {}
    },
    async getFormData (data) {
      this.$vs.loading({container: '#EditCallbackNumberFormContainer'})
      const callbackNumberId = data.id
      try {
        const response = await CallbackNumber.view({ id: callbackNumberId })
        // console.log(response)
        this.formData = response.data.callbackNumber
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
      this.$vs.loading.close('#EditCallbackNumberFormContainer > .con-vs-loading')
    },
    async updateFormData () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editCallbackNumberButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await CallbackNumber.update({ ...this.formData })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.resetFormData()
          this.$emit('editCallbackNumberSuccess')
        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })

        this.formDataErrors = this.__getTranslatedValidationErrors(errors.validationErrors)
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#editCallbackNumberButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
  #editCallbackNumberButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
